import React, { FC, ReactNode } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import denticareTheme from 'config/denticare';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/cjs/Page/AnnotationLayer.css';
import 'react-pdf/dist/cjs/Page/TextLayer.css';

// STYLES
import { EInvoiceWrapper } from './styles';

interface AppContainerProps {
  children: ReactNode;
}
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const AppContainer: FC<AppContainerProps> = ({ children }) => (
  <EInvoiceWrapper>
    <ChakraProvider theme={denticareTheme}>{children}</ChakraProvider>
  </EInvoiceWrapper>
);

export default AppContainer;
